export const BACKGROUND_DARK_COLOR = '#2b2c2c'
export const BACKGROUND_LIGHT_COLOR = '#2d2e2e'
